export const CustomerTypeEnum = {
  /**药店  1*/
  drugstore: "1",
  /**商业公司 2 */
  business: "2",
  /**医生 3*/
  doctor: "3",
  /**医院 4 */
  hospital: "4",
  /**患者 5 */
  patient: "5",
  /**潜在药店  6*/
  potential_drugstore: "6",
  /**潜在商业公司 7 */
  potential_business: "7",
  /**医院备案药店 8 */
  hospital_drugstore: "8",
  /**供应商  9*/
  supplier: "9",
  /**商业客户 10 */
  business_customer: "10",
  /**居间人 11 */
  intermediary: "11",
  /**专家  12 */
  expert: "12",
  /**科室  13*/
  department: "13",
  /**其他 14 */
  other: "14",
  /**药店联系人 15 */
  drugstore_contact: "15",
  /**所有企业客户类型累计 99 */
  all_customer_type: "99",
};

export const CUSTOMERTYPEMAP = {
  [CustomerTypeEnum.drugstore]: "药店",
  [CustomerTypeEnum.business]: "商业公司",
  [CustomerTypeEnum.doctor]: "医生",
  [CustomerTypeEnum.hospital]: "医院",
  [CustomerTypeEnum.patient]: "患者",
  [CustomerTypeEnum.potential_drugstore]: "潜在药店",
  [CustomerTypeEnum.potential_business]: "潜在商业公司",
  [CustomerTypeEnum.hospital_drugstore]: "医院备案药店",
  [CustomerTypeEnum.supplier]: "供应商",
  [CustomerTypeEnum.business_customer]: "商业客户",
  [CustomerTypeEnum.intermediary]: "居间人",
  [CustomerTypeEnum.expert]: "专家",
  [CustomerTypeEnum.department]: "科室",
  [CustomerTypeEnum.other]: "其他",
  [CustomerTypeEnum.drugstore_contact]: "药店联系人",
  [CustomerTypeEnum.all_customer_type]: "所有企业客户类型累计",
};
